import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useDuration, Duration } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<Duration>
      useData={useDuration}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
